module.exports = require("material-table/dist/utils/common-values");